import React from 'react';
import EstadisticasConsolidadoTabla from './EstadisticasConsolidadoTabla';
import styled from 'styled-components/macro';

const EstadisticasConsolidado =(props)=>{
    return(
        <EstConsolidado>
            {props.data.map((x)=>{
                return( <EstadisticasConsolidadoTabla data={x}/>)
            })}
        </EstConsolidado>
    );
};

const EstConsolidado = styled.section`
width:100%;
  margin-top: 6px;
  background-color: white;
  box-shadow: 0px -7px 18px rgb(0 0 0 / 6%);
  overflow: auto;
  border: 5px solid white;
`;

export default EstadisticasConsolidado;